import React from 'react';
import PropTypes from 'prop-types';
import styles from './Select.module.scss';

const Select = ({
  label,
  error,
  helperText,
  children,
  id,
  className,
  ...rest
}) => {
  const wrapperClasses = [styles.wrapper, className || ''].filter(Boolean).join(' ');
  const selectClasses = [styles.select, error ? styles.selectError : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.selectWrap}>
        <select id={id} className={selectClasses} {...rest}>
          {children}
        </select>
        <span className={styles.chevron} />
      </div>
      {error && <span className={styles.error}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
};

Select.defaultProps = {
  label: '',
  error: '',
  helperText: '',
  id: undefined,
  className: '',
};

export default Select;
